module.exports = __webpack_public_path__ + "static/media/home.e2a84aeb.svg";